export default __webpack_public_path__ + "static/media/header-bg.ba8b7beb.png";